import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

@Injectable()
export class AccessGuardService implements CanActivate, CanActivateChild {

	currentUser:any =null ;
	token:any =null;
	role :string;
	branch :string;

	constructor(private router: Router) { }
	canActivate() {
		console.log('i am checking to see if you are logged in');
		if(localStorage.getItem('currentUser')) {
			console.log('inside canActivate 1st If');
			this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
			this.token = this.currentUser.token;
			this.role = this.currentUser.role;
			this.branch = this.currentUser.branch;
			console.log(this.currentUser);
			console.log(this.token);
			console.log(this.role);
			console.log(this.branch);
			if (this.role === 'Admin' || this.role === 'Manager' || this.role === 'Employee'){
				console.log('inside canActivate 2nd If');
				return true;
			}
			else{
				swal(
					'Authentication Failure', 
					'You do not have necessary permission to access this Page!', 
					'warning'
				);
				return false;
				// this.router.navigate(['login']);
			}

		}

		else{
			swal(
				'Authentication Failure', 
				'You do not have necessary permission to access this Page!', 
				'warning'
			);
			return false;
			// this.router.navigate(['login']);
		}
	}

	canActivateChild() {
		console.log('checking child route access');
		return true;
	}

}


// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_auth/access-guard.service.ts